import { ActionReducerMap, MetaReducer } from "@ngrx/store";
import * as fromRouter from "@ngrx/router-store";
import { routerReducer } from "@ngrx/router-store";
import { environment } from "../../../environments/environment";

export interface RootState {
  router: fromRouter.RouterReducerState<any>;
}

export const reducers: ActionReducerMap<RootState> = {
  router: routerReducer,
};
export const metaReducers: MetaReducer<RootState>[] = !environment.production
  ? []
  : [];
